var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legend"},[_c('div',{staticClass:"legend-color"}),_c('div',{staticClass:"body-text-2"},[_c('strong',[_vm._v(_vm._s(_vm.$t('sliderMinimum')))]),_vm._v("\n\t\t"+_vm._s(_vm.$t('sliderLegend'))+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }